import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ForgeCard, ForgeLinearProgress } from '@tylertech/forge-react';
import { getMoneyObj } from '../../reusable/MoneyJsHelpers.js';

const ProgramMatchCard = ({ data, className, programTotalCost }) => {
  
  const percents = useMemo(() => {
    const costNum = Number(data?.cost);
    const totalNum = Number(programTotalCost);

    if (!totalNum || totalNum === 0 || !costNum) return 0;

    const costObj = getMoneyObj(costNum);
    const totalObj = getMoneyObj(totalNum);

    const moneyPercent = Number(totalObj.divide(costObj).amount / 100).toFixed(2);
    return moneyPercent;

  }, [data?.cost, programTotalCost]);

  const linearProgress = useMemo(() => {
    const normalizedDistance = Math.min(
      Math.max(Number(data.distance) || 0, 0),
      1
    );
    
    if (normalizedDistance > 1) return 1;
    const similarity = 1 - normalizedDistance;

    return Number(similarity).toFixed(2);
  }, [data]);

  return (
    <ForgeCard className={`safari-card-flex ${className}`}>
      <div className="forge-typography--heading4">{data.program}</div>
      <div className="flexContainer direction-column">
        <div className="forge-typography--body1">{data?.organization_name}</div>
        <div className="forge-typography--body1">{data?.department}</div>
        <div className="forge-typography--body1">Cost: {data?.cost && data?.pop ? (data.cost / data.pop).toFixed(2) : '0.00'}/capita</div>
      </div>
      <div className="forge-typography--body1 success-color marginTop">{`${percents}%`} vs your cost.</div>
      <div className="flexContainer direction-column marginTop">
        <ForgeLinearProgress
          determinate
          progress={linearProgress}
        />
        <div className="flexContainer spaceBetween alignVertically marginTop">
          <span>Total: {Number(linearProgress * 100).toFixed(2)}%</span>
        </div>
      </div>
    </ForgeCard>
  );
};
ProgramMatchCard.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
  programTotalCost: PropTypes.number,
};
export default ProgramMatchCard;
